import { Lang } from 'Roblox';
import angular from 'angular';

let robux = angular
    .module("robux", ["robloxApp", "modal", "premium"])
    .config(['$injector',
        function ($injector) {
            var languageResourceProvider = $injector.get("languageResourceProvider");
            if (Lang.PremiumResources) {
                languageResourceProvider.setLanguageKeysFromFile(Lang.PremiumResources);
            }
            if (Lang.ExternalLinksResources) {
                languageResourceProvider.setLanguageKeysFromFile(Lang.ExternalLinksResources);
            }
        }]);

export default robux;